document.addEventListener("DOMContentLoaded", () => {
  // Handle each block instance separately
  document.querySelectorAll(".cav-team-display").forEach((block) => {
    const list = block.querySelector(".cav-team-display__list");
    const modal = block.querySelector(".cav-team-display__modal");

    if (!list || !modal) return;

    const modalItems = modal.querySelectorAll(".cav-team-display__modal--item");

    function closeModal() {
      modal.classList.remove("is-active");
      modalItems.forEach((item) => item.classList.remove("is-active"));
      document.body.classList.remove("cav-modal-open");
    }

    function openModal(teamId) {
      // Clear previous
      modalItems.forEach((item) => item.classList.remove("is-active"));

      const target = modal.querySelector(`#team${teamId}`);
      if (!target) return;

      modal.classList.add("is-active");
      target.classList.add("is-active");
      document.body.classList.add("cav-modal-open");
    }

    // Event delegation for list clicks
    list.addEventListener("click", (e) => {
      const link = e.target.closest("a[data-team]");
      if (!link) return;

      e.preventDefault();

      const teamId = link.getAttribute("data-team");
      if (!teamId) return;

      openModal(teamId);
    });

    // Close when clicking outside modal item (backdrop)
    modal.addEventListener("click", (e) => {
      // If click is directly on modal backdrop, close
      if (e.target === modal) {
        closeModal();
      }
    });

    // Close on ESC
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modal.classList.contains("is-active")) {
        closeModal();
      }
    });

    // Optional: add close buttons inside modal items
    modal.querySelectorAll("[data-modal-close]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        closeModal();
      });
    });
  });
});
